import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Template from './interfaz/Template';
import * as etiquetas from '../ApplicationResources.js';
import AuthenticatedComponent from './AuthenticatedComponent.js'
import axios from 'axios';
import {Button, Form, Select} from 'antd';
import {connect} from 'react-redux';
import '../css/options_menu.css';

const {Option} = Select;

class SeleccionProceso extends Component {
	constructor(props) {
		super(props);

		this.state = {
			listaDetalles : null,
			detalleId: 'Selecciona una opción',
			procesoId: null,
			btnContinuarDeshabilitado: true
		  };
	}

	/**
	* Obtiene la lista de los estados para el filtro de OC
	**/
	obtenerListaDetalles = async () =>{
		var postData = {
			"idEstado": localStorage.getItem('id_estado')
		};
		const detalles = await axios.post(process.env.REACT_APP_API_URL +
			"/centralReclutaSEyCAE/ws/obtenerDetalles", postData
					, {
							headers: {
								'Accept': 'application/json'
								 ,'Content-Type': 'application/json'
							}
					}
			);

			return JSON.parse(JSON.stringify(detalles.data));
	}

	obtenerProcesoElectoral(){
		this.setState({btnContinuarDeshabilitado : true});

		var postData = {
				idDetalleProceso : localStorage.getItem('id_detalle_proceso')
			}

		  axios.post(process.env.REACT_APP_API_URL +
			"/centralReclutaSEyCAE/ws/obtenerProcesoElectoral", postData,
				{
					headers: {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json'
					}
				}
			 ).then(response => {
			  this.setState({
						  procesoId : response.data !== null ?
										response.data : 0
					  });

			  localStorage.setItem('id_proceso_electoral', this.state.procesoId);

			  if(this.state.procesoId !== null)
				  this.setState({btnContinuarDeshabilitado : false});
			  else
			      this.setState({btnContinuarDeshabilitado : true});
		  }).catch(error => {
			var msjError = "";
			console.error("Error al consultar el proceso electoral "+
				"obtenerProcesoElectoral()",error);
		  });
	}

	componentWillMount() {
		this.obtenerListaDetalles()
		.then(listaDetalles => {
			this.setState(
					{
					listaDetalles: listaDetalles
					}
				);
		})
		.catch(error => {
		  console.error("Error al obtener lista de detalles procesos "+
			  "componentWillMount()",error);
		  
	
		});
	}

	handleDetalleChange = (detalleId) => {
		localStorage.setItem('id_detalle_proceso', detalleId);

		this.setState({
			detalleId:detalleId
		 });

		 this.obtenerProcesoElectoral();
	}

	redireccionar = () => {
		this.props.history.push('/menuJDE');
	}

	render() {
		return (
			<AuthenticatedComponent externo={false}>
				<Template contenido={
				  <>
					  <div className='pantalla_proceso'>
						<div className='combo_proceso_detalle'>
							<Form id="form-procesos">
								<h3 className='encabezado_proceso'>Selecciona el Proceso Electoral:</h3>
								<Select className="select_form"
								placeholder="Selecciona una opción" id="lista-procesos"
								value={this.state.detalleId}
								onChange={this.handleDetalleChange}
								>
									{
										this.state.listaDetalles &&
										this.state.listaDetalles.map((detalle, index) => (
											<Option key={index} value={detalle.id}>
												{detalle.valor}
											</Option>
										))
									}
								</Select>
								<Button onClick={this.redireccionar} disabled={this.state.btnContinuarDeshabilitado}>
									Siguiente
								</Button>
								</Form>
						</div>
					</div>
	
				  </>
				}
				guia={false}/>
			  </AuthenticatedComponent>
		);
	}
};

const mapStateToProps = state => {
	var datosUsuario;
  
	if (state.sesion.datosUsuario) {
		datosUsuario = state.sesion.datosUsuario;
	}
  
	return {
		datosUsuario: datosUsuario,
	};
  }
  
  export default connect(mapStateToProps)(SeleccionProceso);
